"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getLastTokenOperations = exports.getLastCoinOperations = exports.ETHERSCAN_TIMEOUT = exports.DEFAULT_RETRIES_API = void 0;
var axios_1 = __importDefault(require("axios"));
var cache_1 = require("../../../cache");
var errors_1 = require("../errors");
var promise_1 = require("../../../promise");
var adapters_1 = require("../adapters");
exports.DEFAULT_RETRIES_API = 5;
exports.ETHERSCAN_TIMEOUT = 5000; // 5 seconds between 2 calls
function fetchWithRetries(params, retries) {
    if (retries === void 0) { retries = exports.DEFAULT_RETRIES_API; }
    return __awaiter(this, void 0, void 0, function () {
        var data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 5]);
                    return [4 /*yield*/, axios_1["default"].request(params)];
                case 1:
                    data = (_a.sent()).data;
                    if (!Number(data.status) && data.message === "NOTOK") {
                        throw new errors_1.EtherscanAPIError("Error while fetching data from Etherscan like API", { params: params, data: data });
                    }
                    return [2 /*return*/, data.result];
                case 2:
                    e_1 = _a.sent();
                    if (!retries) return [3 /*break*/, 4];
                    // wait the API timeout before trying again
                    return [4 /*yield*/, (0, promise_1.delay)(exports.ETHERSCAN_TIMEOUT)];
                case 3:
                    // wait the API timeout before trying again
                    _a.sent();
                    // decrement with prefix here or it won't work
                    return [2 /*return*/, fetchWithRetries(params, --retries)];
                case 4: throw e_1;
                case 5: return [2 /*return*/];
            }
        });
    });
}
/**
 * Get all the last "normal" transactions (no tokens / NFTs)
 */
exports.getLastCoinOperations = (0, cache_1.makeLRUCache)(function (currency, address, accountId, fromBlock) { return __awaiter(void 0, void 0, void 0, function () {
    var apiDomain, url, ops;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                apiDomain = (_b = (_a = currency.ethereumLikeInfo) === null || _a === void 0 ? void 0 : _a.explorer) === null || _b === void 0 ? void 0 : _b.uri;
                if (!apiDomain) {
                    return [2 /*return*/, []];
                }
                url = "".concat(apiDomain, "/api?module=account&action=txlist&address=").concat(address, "&tag=latest&page=1&sort=desc");
                if (fromBlock) {
                    url += "&startBlock=".concat(fromBlock);
                }
                return [4 /*yield*/, fetchWithRetries({
                        method: "GET",
                        url: url
                    })];
            case 1:
                ops = _c.sent();
                return [2 /*return*/, ops
                        .map(function (tx) { return (0, adapters_1.etherscanOperationToOperation)(accountId, tx); })
                        .filter(Boolean)];
        }
    });
}); }, function (currency, address, accountId) { return accountId; }, { ttl: 6 * 1000 });
/**
 * Get all the last ERC20 transactions
 */
exports.getLastTokenOperations = (0, cache_1.makeLRUCache)(function (currency, address, accountId, fromBlock) { return __awaiter(void 0, void 0, void 0, function () {
    var apiDomain, url, ops;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                apiDomain = (_b = (_a = currency.ethereumLikeInfo) === null || _a === void 0 ? void 0 : _a.explorer) === null || _b === void 0 ? void 0 : _b.uri;
                if (!apiDomain) {
                    return [2 /*return*/, []];
                }
                url = "".concat(apiDomain, "/api?module=account&action=tokentx&address=").concat(address, "&tag=latest&page=1&sort=desc");
                if (fromBlock) {
                    url += "&startBlock=".concat(fromBlock);
                }
                return [4 /*yield*/, fetchWithRetries({
                        method: "GET",
                        url: url
                    })];
            case 1:
                ops = _c.sent();
                return [2 /*return*/, ops
                        .map(function (event) { return (0, adapters_1.etherscanERC20EventToOperation)(accountId, event); })
                        .filter(Boolean)];
        }
    });
}); }, function (currency, address, accountId) { return accountId; }, { ttl: 6 * 1000 });
exports["default"] = {
    getLastCoinOperations: exports.getLastCoinOperations,
    getLastTokenOperations: exports.getLastTokenOperations
};
//# sourceMappingURL=etherscan.js.map